/** biome-ignore-all lint/style/noNonNullAssertion: This is hte proper way to initialize the router context. See https://tanstack.com/router/latest/docs/framework/react/examples/authenticated-routes */
import { type QueryClient, useQueryClient } from '@tanstack/react-query'
import {
	createRouter,
	RouterProvider as TanStackRouterProvider,
} from '@tanstack/react-router'
import { routeTree } from '@/routeTree.gen.ts'
import {
	type FeatureFlagKey,
	isFeatureFlagEnabled,
} from '@/shared/core/hooks/use-feature-flag/use-feature-flag.ts'

interface RouterContext {
	isFeatureFlagEnabled: (featureFlags: FeatureFlagKey) => boolean
	queryClient: QueryClient
}

// biome-ignore lint/style/useComponentExportOnlyModules: router instance must be co-located with RouterProvider
export const router = createRouter({
	context: {
		isFeatureFlagEnabled: undefined!,
		queryClient: undefined!,
	} as RouterContext,
	defaultPreload: 'intent',
	defaultPreloadStaleTime: 0,
	routeTree,
})

export function RouterProvider() {
	const queryClient = useQueryClient()

	return (
		<TanStackRouterProvider
			context={{
				isFeatureFlagEnabled,
				queryClient,
			}}
			router={router}
		/>
	)
}
